export default __webpack_public_path__ + "static/media/38.89d0760e.jpeg";